import '../PlataformaEducativa/Footer2/Footer2.css'
import logo from '../Assets/Img/Logo.png'
import logob from '../Assets/Img/Logoenblanco.png'
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer-container">

      {/* Línea decorativa */}
      <div className="footer-top-line"></div>

      {/* CONTENIDO */}
      <div className="footer-content">
        <div className="footer-main">

          {/* Branding */}
          <div className="footer-brand">

            <div className="brand-header">
              <img src={logo} className="logo-imag" alt="Tresatec" />
              <span className="brand-name">TRESATEC</span>
            </div>

            <p className="brand-description">
              Nos especializamos en el desarrollo de software educativo y
              soluciones digitales a medida de formación y capacitación
              para empresas e instituciones educativas.
            </p>

            <div className="brand-tag">
              <i className='bx bx-chip'></i>
              <span>Innovación educativa con tecnología</span>
            </div>

          </div>

          {/* Navegación */}
          <div className="footer-links">

            <div className="links-header">
              <i className='bx bx-grid-alt'></i>
              <h4>Navegación</h4>
            </div>

            <ul className="links-list">

              <li>
                <Link className="footer-link-item" to="/">
                  <i className='bx bx-home'></i>
                  <span>Inicio</span>
                </Link>
              </li>

              <li>
                <Link className="footer-link-item" to="/AboutUs">
                  <i className='bx bx-info-circle'></i>
                  <span>Sobre Nosotros</span>
                </Link>
              </li>

              <li>
                <Link className="footer-link-item" to="/Servicios">
                  <i className='bx bx-briefcase'></i>
                  <span>Modulos</span>
                </Link>
              </li>

              <li>
                <Link className="footer-link-item" to="/Contactos">
                  <i className='bx bx-envelope'></i>
                  <span>Contacto</span>
                </Link>
              </li>

            </ul>

          </div>

          {/* Redes */}
          <div className="footer-social">

            <div className="social-header">
              <i className='bx bx-share-alt'></i>
              <h4>Conectemos</h4>
            </div>

            <p className="social-description">
              Seguinos en nuestras redes o comunicate con nosotros.
            </p>

            <div className="social-icons-grid">

              <a href='https://www.instagram.com/tresatec/' target='_blank' rel="noopener noreferrer" className="social-icon-item">
                <i className='bx bxl-instagram'></i>
                <span>Instagram</span>
              </a>

              <a href='https://wa.me/message/ORWIOZ4UP74NM1' target='_blank' rel="noopener noreferrer" className="social-icon-item">
                <i className='bx bxl-whatsapp'></i>
                <span>WhatsApp</span>
              </a>

              <button
                onClick={() => window.location.href = 'mailto:tresatec1@gmail.com'}
                className="social-icon-item"
              >
                <i className='bx bxl-gmail'></i>
                <span>Email</span>
              </button>

              <a href='https://www.linkedin.com/company/tresatec' target='_blank' rel="noopener noreferrer" className="social-icon-item">
                <i className='bx bxl-linkedin'></i>
                <span>LinkedIn</span>
              </a>

            </div>

            <div className="platform-access">

              <Link to="/Demo/" className="platform-btn">
                <img src={logob} className="logo-blan" alt="plataforma" />
                <span>Acceder a la plataforma</span>
              </Link>

            </div>

          </div>

        </div>
      </div>

      {/* Línea divisoria */}
      <div className="footer-divider"></div>

      {/* Créditos */}
      <div className="footer-bottom">

        <div className="footer-credits">

          <div className="credits-content">
            <span className="credits-text">
              <i className='bx bx-copyright'></i>
              2023 Tresatec
            </span>

            <span className="credits-tagline">
              Transformando la educación con tecnología
            </span>
          </div>

          <div className="credits-logo">
            <img src={logo} alt="Tresatec" />
          </div>

        </div>

      </div>

    </footer>
  );
}

export default Footer;